var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11671_14219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6895 8.9565C9.9335 8.3175 9.5 7.3835 9.5 6.394V5C9.5 3.2405 8.193 1.784 6.5 1.54V1C6.5 0.7235 6.276 0.5 6 0.5C5.724 0.5 5.5 0.7235 5.5 1V1.54C3.8065 1.784 2.5 3.2405 2.5 5V6.394C2.5 7.3835 2.0665 8.3175 1.306 8.9605C1.1115 9.127 1 9.369 1 9.625C1 10.1075 1.3925 10.5 1.875 10.5H10.125C10.6075 10.5 11 10.1075 11 9.625C11 9.369 10.8885 9.127 10.6895 8.9565Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 12.5C6.90559 12.5 7.66309 11.8545 7.83709 11H4.16309C4.33709 11.8545 5.09459 12.5 6.00009 12.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11671_14219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fbdc133ab6be4b881458a4512a2a241f.svg";
export { ForwardRef as ReactComponent };